import React, { useMemo } from 'react';
import WhatsMarked from 'react-whatsmarked';
import './style.css';

function saudacaoComBaseNoHorario() {
  const hora = new Date().getHours();
  if (hora < 12) return 'Bom dia!';
  if (hora < 18) return 'Boa tarde!';
  return 'Boa noite!';
}

function formatNow() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

const ChatComponent = ({ text }) => {
  const messages = useMemo(() => {
    const raw = (text ?? '').replace('{{saudacao}}', saudacaoComBaseNoHorario());
    return raw
      .split('{{dividir_texto}}')
      .map((m) => m.trim())
      .filter((m) => m.length > 0);
  }, [text]);

  const timestamp = formatNow();

  return (
    <div className="chat-wrapper">
      <div className="chat">
        <div className="mine messages">
          {messages.length === 0 ? (
            <div className="chat-empty">Sua mensagem aparecerá aqui</div>
          ) : (
            messages.map((message, i) => {
              const isLast = i === messages.length - 1;
              return (
                <div
                  key={i}
                  className={isLast ? 'message last' : 'message'}
                >
                  <div className="message-body">
                    <WhatsMarked>{message}</WhatsMarked>
                  </div>
                  <div className="message-meta">
                    <span className="message-time">{timestamp}</span>
                    <span className="message-tick" aria-hidden>✓✓</span>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatComponent;
